declare let Terminal: any;

export type TerminalBinding = {
  clean: () => void;
  writeLine: (data: string) => void;
  write: (data: string) => void;
};

export type TerminalInstance = {
  term: any;
  binding: TerminalBinding;
};

export function createTerminal(container: HTMLElement): TerminalInstance {
  const term = new Terminal({
    cols: 80,
    rows: 30,
    scrollOnInput: true,
    cursorBlink: true,
    fontSize: 14,
    fontFamily: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace",
    theme: {
      background: "#ffffff",
      foreground: "#000000",
      cursor: "#000000",
    },
  });

  term.open(container);
  term.onData(() => term.scrollToBottom());

  const binding: TerminalBinding = {
    clean() {
      term.clear();
    },
    writeLine(data: string) {
      console.log("Terminal write:", data);
      term.writeln(data);
      term.scrollToBottom();
    },
    write(data: string) {
      console.log("Terminal write:", data);
      term.write(data);
      term.scrollToBottom();
    },
  };

  return { term, binding };
}
